"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_router_1 = require("react-router");
var DealResponseCodes_1 = require("../enum/DealResponseCodes");
var Routes_1 = require("../enum/Routes");
/**
 * @returns function
 *   Callback that will handle the error and notify whether it was specific deal error.
 *   Returns false if error was handled, or the error in case it was not.
 */
function useDealErrorHandler(overrideHistory) {
    var history = overrideHistory || react_router_1.useHistory();
    return function (error) {
        var _a, _b;
        if (!((_a = error) === null || _a === void 0 ? void 0 : _a.response)) {
            return error;
        }
        var code = (_b = error.response.data) === null || _b === void 0 ? void 0 : _b.code;
        var isAccessDenied = error.response.status === 403 ||
            code === DealResponseCodes_1.DealResponseCodes.INVALID_DEAL_STATUS ||
            code === DealResponseCodes_1.DealResponseCodes.ACCESS_CODE_DENIED;
        if (isAccessDenied) {
            history.replace(Routes_1.Routes.ACCESS_DENIED);
            return false;
        }
        var isDealUnavailable = (error.response.status === 404 && code === DealResponseCodes_1.DealResponseCodes.NO_ACTIVE_DEAL) ||
            (error.response.status === 404 && (!error.response.data || Object.keys(error.response.data).length === 0)) ||
            (error.response.status === 400 && code === DealResponseCodes_1.DealResponseCodes.EXPIRED_DEAL);
        if (isDealUnavailable) {
            history.replace(Routes_1.Routes.DEAL_UNAVAILABLE, { isExpired: code === DealResponseCodes_1.DealResponseCodes.EXPIRED_DEAL });
            return false;
        }
        return error;
    };
}
exports.default = useDealErrorHandler;
